/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import EventFaceSearchPage from './EventFaceSearchPage';
import QueryHandler from '../components/misc/QueryHandler';

import { getCustomerKey } from '../utils/browser-storage';

class EventFaceSearchPageQueryRenderer extends Component {
  constructor(props) {
    super(props);

    this.snFromUrl = props.match.params.startnumber;
    this.eventIdFromUrl = props.match.params.id;
    this.faceStartnumberFromUrl = props.match.params.facestartnumber;
    this.customerKey = getCustomerKey(this.eventIdFromUrl, this.snFromUrl);
  }

  render() {
    const { match } = this.props;

    return (
      <QueryHandler
        query={graphql`
          query EventFaceSearchPageQueryRendererQuery(
            $eventId: ID!
            $language: String
            $startnumber: ID!
            $faceStartnumber: ID!
            $count: Int!
            $cursor: String
            $secondFactor: String
            $individualPart: String
            $noStartnumber: Boolean
          ) {
            viewer {
              ...EventFaceSearchPage_viewer
            }
          }
        `}
        variables={{
          eventId: this.eventIdFromUrl,
          language: match.params.language,
          startnumber: this.snFromUrl !== undefined ? this.snFromUrl : '',
          faceStartnumber: this.faceStartnumberFromUrl,
          count: MEDIA_FETCH_COUNT,
          secondFactor: this.customerKey,
          individualPart: '',
          noStartnumber: this.snFromUrl === undefined,
        }}
        redirectTo={`/event/${this.eventIdFromUrl}`}
        render={props => {
          return (
            <EventFaceSearchPage
              viewer={props.viewer}
              snFromUrl={match.params.startnumber}
              faceStartnumberFromUrl={match.params.facestartnumber}
              customerKey={this.customerKey}
            />
          );
        }}
      />
    );
  }
}

EventFaceSearchPageQueryRenderer.propTypes = {
  match: PropTypes.object,
};

export default EventFaceSearchPageQueryRenderer;
